// @ts-nocheck
import { UPGRADE_REQUEST_LIST_ERROR, UPGRADE_REQUEST_LIST_LOADING, UPGRADE_REQUEST_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const UpgradeRequestListReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPGRADE_REQUEST_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case UPGRADE_REQUEST_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case UPGRADE_REQUEST_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}
